<template>
  <div
    :id="id"
    class="section"
  >
    <div class="title has-text-centered"><span class="shadow">{{ title }}</span></div>
    <HomeCard
      v-for="(element, index) in list"
      :key="index"
      :title="element.title"
      :period="element.period"
      :subtitle="element.subtitle"
      :tags="element.tags"
      :links="element.links"
    >
      <figure
        slot="img"
      >
        <img :src="require(`@/assets/img/home/${element.img}`)">
      </figure>
    </HomeCard>
  </div>
</template>

<script>

import HomeCard from './HomeCard.vue';

export default {
  components: {
    HomeCard,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    list: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

.title {
  font-size: $size-2;

  @include mobile {
    width: 100%;
    font-size: $size-3;
  }
  .shadow {
    box-shadow: inset 0 -6px 0 rgba(0, 173, 181, 0.5);
  }
}

</style>
